import { render, staticRenderFns } from "./yanpian.vue?vue&type=template&id=7c835406&scoped=true&"
import script from "./yanpian.vue?vue&type=script&lang=js&"
export * from "./yanpian.vue?vue&type=script&lang=js&"
import style0 from "./yanpian.vue?vue&type=style&index=0&id=7c835406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c835406",
  null
  
)

export default component.exports